<template>
    <form class="m-form m-form--fit m-form--label-align-right">
        <div class="modal fade" id="change_pass_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" style="display: none;" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Thay đổi mật khẩu
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                ×
                            </span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group m-form__group">
                            <label for="old_password">
                                Mật khẩu cũ
                            </label>
                            <input type="password" class="form-control m-input m-input--solid" v-model="oldPass" id="old_password">
                        </div>
                        <div class="form-group m-form__group">
                            <label for="new_password">
                                Mật khẩu mới
                            </label>
                            <input type="password" class="form-control m-input m-input--solid" v-model="newPass" id="new_password">
                            <span class="m-form__help">
                                Mật khẩu phải chứa ít nhất 6 kí tự!
                            </span>
                        </div>
                        <div class="form-group m-form__group">
                            <label for="new_password_confirm">
                                Xác nhận lại mật khẩu mới
                            </label>
                            <input type="password" class="form-control m-input m-input--solid" v-model="confirmPass" id="new_password_confirm">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            Hủy bỏ
                        </button>
                        <button type="button" class="btn btn-primary" @click="this.changePassword">
                            Lưu
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        // props: ['changePass'],
        
        data(){
            return {
                oldPass: "",
                newPass: "",
                confirmPass: ""
            }
        },

        methods: {
            changePassword: async function(){
                if(this.oldPass == ""){
                    swal("", "Mật khẩu cũ không được để trống!", "error");
                    return;
                }

                if(this.newPass == ""){
                    swal("", "Mật khẩu mới không được để trống!", "error");
                    return;
                }

                if(this.confirmPass == ""){
                    swal("", "Vui lòng nhập xác nhận mật khẩu mới!", "error");
                    return;
                }

                if(this.newPass != this.confirmPass){
                    swal("", "Mật khẩu với và mật khẩu xác nhận không khớp nhau!", "error");
                    return;
                }

                if(this.newPass.length < 6){
                    swal("", "Mật khẩu mới phải chứa ít nhất 6 kí tự!", "error");
                    return;
                }

                let res = await window.axios.post("/admin-panel/user-info/change_pass", {
                    old_pass: this.oldPass,
                    new_pass: this.newPass
                });

                if(res.data.code == 0){
                    swal("", "Mật khẩu đã được đổi thành công!", "success");
                }else{
                    swal("Lỗi", res.data.msg, "error");
                }
            }
        }
    }

</script>

<style type="text/css">
    .m-form.m-form--fit .m-form__content, .m-form.m-form--fit .m-form__group, .m-form.m-form--fit .m-form__heading {
        padding-left: 30px;
        padding-right: 30px;
    }

    .m-form .m-form__group {
        margin-bottom: 0;
        padding-top: 15px;
        padding-bottom: 15px;
    }

    .form-group {
        margin-bottom: 1rem;
    }

    .form-control.m-input--solid {
        background-color: #f4f5f8;
        border-color: #f4f5f8;
        color: #575962;
    }
    .form-control, .form-control[readonly] {
        border-color: #ebedf2;
        color: #575962;
    }
    .form-control {
        font-family: sans-serif,Arial;
        -webkit-border-radius: 0;
        -moz-border-radius: 0;
        -ms-border-radius: 0;
        -o-border-radius: 0;
        border-radius: 0;
        -webkit-border-radius: .25rem;
        -moz-border-radius: .25rem;
        -ms-border-radius: .25rem;
        -o-border-radius: .25rem;
        border-radius: .25rem;
    }
    .form-control {
        display: block;
        width: 100%;
        padding: .65rem 1rem;
        font-size: 1rem;
        line-height: 1.25;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: .25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }

    .m-form span.m-form__help {
        display: inline-block;
    }
    .m-form .m-form__help {
        color: #7b7e8a;
    }
    .m-form .m-form__help {
        font-weight: 300;
        font-size: .85rem;
        padding-top: 7px;
    }
</style>